import { useEffect } from "react";
import { SITE } from "@/data/site";

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export const Seo = ({ title, description, path = "/", noindex = false }) => {
  useEffect(() => {
    const url = `${SITE.url}${path === "/" ? "/" : path}`;
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="robots"]', "content", noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1");
  }, [title, description, path, noindex]);
  return null;
};
